import styled from "styled-components";

export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 0.2rem;

  & > div:first-child {
    align-self: flex-start;
  }

  & > div:last-child {
    align-self: flex-end;
  }
`;

export const IncidentSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
  margin-top: 1rem;
`;

export const IncidentSummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const IncidentSummaryLabel = styled.span`
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--pagina_text_color);
`;

export const IncidentSummaryValue = styled.span`
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--main-purple-light);
  word-break: break-word;
`;
